/* eslint-disable @typescript-eslint/no-explicit-any */
import CanvasManager from "./CanvasManager";
import { fabric } from '@/@corefabriccanvas/fabric/dist/fabric'

export class ImageManager {
  private canvasManager: CanvasManager;

  constructor(canvasManager: CanvasManager) {
    this.canvasManager = canvasManager;
  }

  addImage(imageUrl: string, config: any, width?: number): void {
    fabric.Image.fromURL(imageUrl, (img: any) => {
      const scale= width ? width / img.width : 1;

      if (false) {
        const rect = new fabric.Rect({
            left: img.left || 0,
            top: img.top || 0,
            width: img.width * scale,
            height: img.height * scale,
            fill: "white",
            selectable: false
        });

        this.canvasManager.addObject(rect);
        this.canvasManager.moveObjectToBack(rect);
    }

      img.set(config);
      this.canvasManager.addObject(img);
       this.canvasManager.moveObjectToBack(img);
      if(!config.scale){
        img.scale(scale);
      }

    });
  }
}
